/**
 * Created by Administrator on 2017/9/22.
 */
import { Injectable }                       from '@angular/core';
import { StroageService }                   from '../service/stroage';

@Injectable()
export class CommonService{
  constructor(
    public stroage:StroageService
  ){}
  public permission:any=JSON.parse(this.stroage.getStroage("fontendPermission"));

  /**
   * 获取某个模块的权限
   * @param code 模块的code值
   * @returns {{viewPermission: boolean, editPermission: boolean, createPermission: boolean}}
     */
  public getPermissionByCode (code:string):any{
    this.permission=JSON.parse(this.stroage.getStroage("fontendPermission"));
    let permissionSum=0;
    let viewPermission=0;
    let editPermission=0;
    let createPermission=0;
    for(let i=0; i<this.permission.length;i++){
      for (let j=0; j<this.permission[i].children.length;j++){
        if(code==this.permission[i].children[j].code){
          permissionSum=this.permission[i].children[j].permission;
          viewPermission=permissionSum&2;
          editPermission=permissionSum&4;
          createPermission=permissionSum&1;
          break;
        }
      }
    }
    return {
      viewPermission:viewPermission==2?true:false,
      editPermission:editPermission==4?true:false,
      createPermission:createPermission==1?true:false
    };
  }


  /**
   * 设置复选框的值为false
   * @param arr 目标数组 处理后返回
   * @returns {[{any:any}]} or {[any]}
   */
  public setValToFalse(arr:any):any{
    for(let i=0;i<arr.length;i++){
      arr[i].val=false;
    }
    return arr;
  }


  /**
   * 通过比较两个数组，如果相等则设置val为true 否则为false
   * @param targetArr 目标数组 整理后返回
   * @param effectArr 与目标数组作比较 如果其中的字段相等则为true否则为false
   * @param key 用来比较的字段名 默认为id
   * @returns {[{any:any}]}
   */
  public setValToTrue( targetArr:any,effectArr:any,key?:string,isTest?:string):any{
    if(isTest){
      console.log(key)
      console.log(targetArr)
      console.log(effectArr)
    }
    let _key=key||'id';
      for(let i=0;i<effectArr.length;i++){
        for (let j=0;j<targetArr.length;j++){
          if(_key=='id'){
            if(effectArr[i][_key]==targetArr[j][_key]){
              targetArr[j].val=true;
            }
          }else {
            if(effectArr[i]==targetArr[j][_key]){
              targetArr[j].val=true;
              break;
            }else if(j==targetArr.length-1){
              targetArr[j].val=true;
              targetArr[j].code=effectArr[i];
            }
          }
        }
      }
    return targetArr;
  }

  /**
   * 设置复选框的值为true
   * @param arr 目标数组 处理后返回
   * @returns {[{any:any}]} or {[any]}
   */
  public setAllValToTrue(targetArr:any):any{
    for(let i=0;i<targetArr.length;i++){
      targetArr[i].val=true;
    }
    return targetArr;
  }


  /**
   *获取选中复选框的id或code
   * @param arr 目标数组
   * @param key 用来比较的字段名
   * @param type 要返回的格式
   * @returns {[{id:number}]} or {[any]}
   */
  public getCheckboxVal(arr:any,key:string,type?:string):any{
    let res=[];
    for(let i=0;i<arr.length;i++){
      if(arr[i].val){
        if(type=='json'){
          res.push({id:arr[i][key]});
        }else {
          res.push(arr[i][key]);
        }
      }
    }
    return res;
  }

  /**
   * 判断是否大于等于10，不够则在前面补零
   * @param data number类型
   * @returns {string}
   */
  public zeroFill(data:any):any{
    let res=parseInt(data)>=10?data:'0'+data;
    return res;
  }

  /**
   * 校验时间格式是否合法
   * @param time HH:MM
   * @returns {boolean}
     */
  public testTime(time:string):boolean{
    let testStr=/^(\d{2})\:\d{2}|\d{4}|(\d{2})\/\d{2}$/;
    let res=testStr.test(time);
    if(!res){

    }
    return res
  }

  //格式化時間 比如0900=>09:00
  public formatTime(time:any):string{
    let res=time;
    if(time.indexOf('/')!=-1){
      res=time.split('/')[0]+":"+time.split('/')[1];
    }
    else if(time.indexOf(':')==-1){
      res=time.substr(0,2)+":"+time.substr(2,2);
    }
    return res;
  }

  public dateFormat (date:any,fmt?: any):string{
    if(!date){
      return '';
    }
    date=new Date(date);
    let o = {
      "M+" : date.getMonth()+1,                 //月份
      "d+" : date.getDate(),                    //日
      "h+" : date.getHours(),                   //小时
      "m+" : date.getMinutes(),                 //分
      "s+" : date.getSeconds(),                 //秒
      "q+" : Math.floor((date.getMonth()+3)/3), //季度
      "S"  : date.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt))
      fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
      if(new RegExp("("+ k +")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/service/common.ts